import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class SearchInformation {
    private dropDownValue;
    private claim : {
        number
        dol
        firstName
        lastName
    };
    private policy : {
        number
        dol
        firstName
        lastName
    }

    getClaim(){
        return this.claim;
    }

    setClaim(claim){
        this.claim = claim;
    }

    getPolicy(){
        return this.policy;
    }

    setPolicy(policy){
        this.policy = policy;
    }

    getDropDownValue(){
        return this.dropDownValue;
    }

    setDropDownValue(dropDownValue){
        this.dropDownValue = dropDownValue;
    }
}
